import type { ValidHref } from '../types';

type UrlHelperParams = {
  pathname: ValidHref;
  searchParams?: { [key: string]: string };
};

// See Node's excellent diagram for parts of a URL
//https://nodejs.org/api/url.html#url_url_strings_and_url_objects
export const createUrl = ({
  pathname,
  searchParams,
}: UrlHelperParams): ValidHref => {
  let newUrl = pathname;

  if (searchParams && Object.keys(searchParams).length > 0) {
    const urlSearchParams = new URLSearchParams(searchParams);
    newUrl += `?${urlSearchParams.toString()}`;
  }

  return newUrl;
};
